import React from "react";
import Permissions from "../../configs/permissions";
import usePermissions from "../../hooks/permissions";
import VabooUserInvoiceEdit from "./VabooUserInvoiceEdit";

const LandlordInvoiceEdit = () => {
  const { protectPage, hasAccess } = usePermissions();
  protectPage(Permissions.Query.ClientInvoice);
  return (
    <VabooUserInvoiceEdit
      updateItemPermission={hasAccess(Permissions.Mutation.UpdateClientInvoice)}
      chargeNowPermission={hasAccess(Permissions.Mutation.ChargeNowClient)}
    />
  );
};

export default LandlordInvoiceEdit;
